import React from 'react';
import PropTypes from 'prop-types';
import SettingContact from "./SettingContact";
import SettingCompanies from "./SettingCompanies";
import SettingOpportunities from "./SettingOpportunities";
import SettingProjects from "./SettingProjects";
import SettingTask from "./SettingTask";
import SettingOther from "./SettingOther";
import SettingLead from "./SettingLead";
import CreationRule from "./CreationRule";
import { Tabs, Tab, Box, Typography, Icon, Switch, FormControlLabel, Card, IconButton, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
const IconSmall = withStyles(() => ({
    root: {
        fontSize: "1.5rem",
    }
}))(Icon);
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box p={2}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}


export default function LeadTab() {


    const data = [
        {
            drag: <Link className="drag-handle" to="#"><Icon>drag_handle</Icon></Link>,
            key: "1",
            name: "jay",
            fieldType: "Text",
            creationRule: <CreationRule />,
            editRule: <CreationRule />,
            action: <IconButton aria-label="edit" size="small">
                <IconSmall>edit</IconSmall>
            </IconButton>,
            active: <FormControlLabel
                value="cardview"
                control={<Switch color="primary" checked />}
                labelPlacement="start"
            />
        },
        {
            drag: <Link className="drag-handle" to="#"><Icon>drag_handle</Icon></Link>,
            key: "1",
            name: "harul",
            fieldType: "Text",
            creationRule: <CreationRule />,
            editRule: <CreationRule />,
            action: <IconButton aria-label="edit" size="small">
                <IconSmall>edit</IconSmall>
            </IconButton>,
            active: <FormControlLabel
                value="cardview"
                control={<Switch color="primary" checked />}
                labelPlacement="start"
            />
        }
    ]
    const [value, setValue] = React.useState(0);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    return (
        <Card elevation={3} className="h-100">
            <h3 className="ml-16 mt-16 mb-16">Customize your fields</h3>
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                className="settings_tabs"
                aria-label="scrollable auto tabs"
            >
                <Tab label="Leads" {...a11yProps(0)} />
                <Tab label="Contacts" {...a11yProps(1)} />
                <Tab label="Companies" {...a11yProps(2)} />
                <Tab label="Opportunities" {...a11yProps(3)} />
                <Tab label="Projects" {...a11yProps(4)} />
                <Tab label="Task" {...a11yProps(5)} />
                <Tab className="ml-auto" label="Other custom field" {...a11yProps(6)} />
            </Tabs>
            <div className="v_scroll position-relative">
                <TabPanel value={value} index={0} className="h-100">                   
                    <SettingLead tabdata={data} />
                </TabPanel>
                <TabPanel value={value} index={1} className="h-100"><SettingContact /></TabPanel>
                <TabPanel value={value} index={2} className="h-100"><SettingCompanies /></TabPanel>
                <TabPanel value={value} index={3} className="h-100"><SettingOpportunities /></TabPanel>
                <TabPanel value={value} index={4} className="h-100"><SettingProjects /></TabPanel>
                <TabPanel value={value} index={5} className="h-100"><SettingTask /></TabPanel>
                <TabPanel value={value} index={6} className="h-100"><SettingOther /></TabPanel>
                
            </div>
        </Card >
    );
}
